import React, { useState, useEffect } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import WrapBottomColor from '../../containers/WrapBottomColor';
import BottomButton from '../../BottomButton';
import { getDirections, getLatLng } from '../../../utils/directions.util';
import { useSelector } from 'react-redux';
import BaseText from '../../BaseText';
import Icon from '../../Icon';
import { Color, CommonProperties } from '../../../styles';
import { useLayoutEffect } from 'react';
import { HeaderTitle } from '@react-navigation/stack';
import { useNavigation } from '@react-navigation/native';
import { Modals } from '../../../constants/ScreenNames';

const options = {
  Apple: { title: 'Apple Maps', value: 'maps' },
  Google: { title: 'Google Maps', value: 'maps' },
  Waze: { title: 'Waze', value: 'waze' },
};

const DirectionModal = ({ route }) => {
  const { page } = route?.params;
  const navigation = useNavigation();
  const { selectedLocation } = route?.params || {};
  useLayoutEffect(() => {
    navigation.setOptions({
      headerTitle: () => <HeaderTitle title="Directions" />,
    });
  }, [navigation]);
  useEffect(() => {
    if (selectedLocation?.inputName === 'fromLocation') {
      setSelectLocation1(selectedLocation.displaylabel);
    }
    if (selectedLocation?.inputName === 'toLocation') {
      setSelectLocation2(selectedLocation.displaylabel);
    }
  }, [selectedLocation]);
  let responseDetails;
  let address;
  if (page == 'car') {
    responseDetails = 'CarResponseDetails';
    address = 'PickupAddress';
  } else if (page == 'hotel') {
    responseDetails = 'HotelResponseDetails';
    address = 'AddressLine1';
  }
  const location = useSelector(
    (state) =>
      state.payment &&
      state.payment?.receiptResponse &&
      state.payment.receiptResponse[0] &&
      state.payment.receiptResponse[0][responseDetails]
  );
  const [check, setCheck] = useState(4);
  const [directionType, setDirectionType] = useState('');
  const [selectLocation1, setSelectLocation1] = useState('My Location');
  const [selectLocation2, setSelectLocation2] = useState(location[address]);
  const enabled = directionType && selectLocation1 && selectLocation2;

  function AddressBox({ icon, text, modal, way }) {
    const modalFunctions = {
      modal: function () {
        navigation.navigate(Modals.StationAutoCompleteModal, {
          returnScreen: route.name,
          source: 'from',
          inputName: way == 'from' ? 'fromLocation' : 'toLocation',
        });
      },
      address: function () {
        // setAddressModal(!addressModal);
        // setLocationModal(false);
      },
      location: function () {
        // selectLocation(whichWay, text);
      },
    };
    return (
      <TouchableOpacity
        onPress={() => {
          modalFunctions[modal](), way;
        }}
        style={styles.address}
      >
        <Icon name={icon} style={[styles.icon, styles.spacing]} size={17} color={Color.primary} />
        <BaseText style={styles.spacing}>{text}</BaseText>
      </TouchableOpacity>
    );
  }

  const onSubmit = async () => {
    const latlng1 = await getLatLng(selectLocation1);
    const latlng2 = await getLatLng(selectLocation2);
    getDirections(directionType, latlng2, latlng1);
  };

  return (
    <WrapBottomColor>
      <View style={styles.container}>
        <AddressBox modal={'modal'} icon={'mark'} text={selectLocation1} way={'from'} />
        <AddressBox modal={'modal'} icon={'mark'} text={selectLocation2} way={'to'} />
        <View style={styles.view}>
          <Icon name="mark" style={[styles.icon, styles.spacing]} size={15} color="#9a9898" />
          <BaseText style={styles.spacing}>Show Directions In</BaseText>
        </View>
        <View>
          {Object.keys(options).map((data, index) => {
            return (
              <View key={index}>
                {check == index ? (
                  <TouchableOpacity style={styles.row}>
                    <View style={styles.checked1}>
                      <View style={styles.checked2} />
                    </View>
                    <BaseText style={styles.spacing}>{options[data].title}</BaseText>
                  </TouchableOpacity>
                ) : (
                  <TouchableOpacity
                    onPress={() => {
                      setCheck(index);
                      setDirectionType(options[data].value);
                    }}
                    style={styles.row}
                  >
                    <View style={styles.unchecked} />
                    <BaseText style={styles.spacing}>{options[data].title}</BaseText>
                  </TouchableOpacity>
                )}
              </View>
            );
          })}
        </View>
      </View>
      <BottomButton disabled={!enabled} label="Get Directions" full onPress={onSubmit} />
    </WrapBottomColor>
  );
};

const styles = StyleSheet.create({
  inputfield: {
    marginHorizontal: '2%',
  },
  max: {
    height: '100%',
    backgroundColor: 'white',
    ...CommonProperties.px3,
  },
  container: {
    flex: 1,
    backgroundColor: 'white',
    ...CommonProperties.px3,
  },

  address: {
    flexDirection: 'row',
    borderWidth: 2,
    borderColor: Color.gray,
    marginTop: '2%',
    marginHorizontal: '1%',
    height: 45,
    borderRadius: 10,
    alignItems: 'center',
    // borderWidth: 0.5,
  },
  view: {
    marginHorizontal: '1%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#e3e3e3',
    height: 35,
    borderRadius: 25,
    marginVertical: '3%',
  },
  spacing: {
    ...CommonProperties.px2,
  },
  unchecked: {
    borderColor: '#9a9898',
    borderWidth: 2,
    height: 20,
    width: 20,
    borderRadius: 10,
  },
  checked1: {
    borderColor: Color.primary,
    borderWidth: 2,
    height: 20,
    width: 20,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checked2: {
    backgroundColor: Color.primary,
    height: 12,
    width: 12,
    borderRadius: 6,
    // alignSelf: 'center',
  },
  text: {
    textAlign: 'center',
    ...CommonProperties.px3,
    ...CommonProperties.py3,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: '1%',
    marginVertical: '1%',
  },
});

export default DirectionModal;
